import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from './truncate.pipe';
import { AgePipe } from './age.pipe';
import { HighlightSearchPipe } from './highlight-search.pipe';
import { PhonePipe } from './phone.pipe';
import { ReplaceLineBreaksPipe } from './replace-line-breaks.pipe';
import { RoundNumberPipe } from './round-number.pipe';
import { SplitStringPipe } from './split.pipe';
import { XmlPipe } from './xml.pipe';
import { StripHtmlPipe } from './strip-html.pipe';
import { MaskInputPipe } from './mask-input.pipe';
import { SafePipe } from './safe.pipe';
import { PluralDaysPipe } from './plural-days.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    TruncatePipe,
    AgePipe,
    HighlightSearchPipe,
    PhonePipe,
    ReplaceLineBreaksPipe,
    RoundNumberPipe,
    SplitStringPipe,
    XmlPipe,
    StripHtmlPipe,
    MaskInputPipe,
    SafePipe,
    PluralDaysPipe
  ],
  exports: [
    TruncatePipe,
    AgePipe,
    HighlightSearchPipe,
    PhonePipe,
    ReplaceLineBreaksPipe,
    RoundNumberPipe,
    SplitStringPipe,
    XmlPipe,
    StripHtmlPipe,
    MaskInputPipe,
    SafePipe,
    PluralDaysPipe
  ]
})
export class PipesModule { }
